import {useCallback, useRef} from 'react'
import {ANIMATION_DEFAULTS} from 'slices/AnimatedTextBlock/components/constants'
import type {ParagraphData} from 'slices/AnimatedTextBlock/components/types'

export function useParagraphCollection() {
  const paragraphsRef = useRef<ParagraphData[]>([])
  const wordsRef = useRef<HTMLElement[]>([])

  const collectParagraphs = useCallback(
    (rootElement: HTMLElement | null, minOpacity = ANIMATION_DEFAULTS.MIN_OPACITY) => {
      if (!rootElement) {
        return
      }

      const paragraphs = Array.from(rootElement.querySelectorAll<HTMLElement>('[data-paragraph]'))
      const list: ParagraphData[] = []

      for (const p of paragraphs) {
        const words = Array.from(p.querySelectorAll<HTMLElement>('[data-word]'))

        for (const w of words) {
          w.style.opacity = minOpacity.toString()
          w.style.filter = `blur(${ANIMATION_DEFAULTS.BLUR_MAX}px)`
          w.style.willChange = 'opacity, filter'
        }

        list.push({el: p, words})
      }

      paragraphsRef.current = list
      wordsRef.current = list.flatMap((p) => p.words)
    },
    [],
  )

  return {paragraphsRef, wordsRef, collectParagraphs}
}
